// eslint-disable-next-line no-unused-vars
import httpClient from './httpClient';

export default {
  decodeVin: (vin, apiKey, externalId, make, model, trim) => {
    let queryParamString = '';

    // Create a queryParams array and filter out any falsy values
    const queryParams = [
      ['apiKey', apiKey],
      ['externalId', externalId],
      ['make', make],
      ['model', model],
      ['trim', trim],
    ].filter(x => !!x[1]);

    if (queryParams.length) {
      queryParamString = '?';

      queryParams.forEach(elem => {
        queryParamString += `${elem[0]}=${elem[1]}&`;
      });

      // chop off the last '&'
      queryParamString = queryParamString.substring(0, queryParamString.length - 1);
    }

    return httpClient.get(`/api/vin-decoder/${vin}${queryParamString}`);
  },
  siriusXmBannerInfo: (vin, apiKey, externalId, language, make, condition) => {
    const urlParams = new URLSearchParams();
    urlParams.append('language', language);
    urlParams.append('make', make);
    urlParams.append('condition', condition);

    return httpClient.get(`/api/sirius-xm/${apiKey}/${externalId}/${vin}?${urlParams.toString()}`);
  },
};
